(function () {
  'use strict';

  function getFocusable(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (node) {
        return !node.hidden && node.getAttribute('aria-hidden') !== 'true';
      });
  }

  function initMenu(root) {
    if (!root) return;

    var toggle = root.querySelector('[data-ghost-menu-toggle]');
    var mobileNav = root.querySelector('[data-ghost-mobile-nav]');
    if (!toggle || !mobileNav || root.dataset.menuInit === 'true') return;

    root.dataset.menuInit = 'true';

    var panel = mobileNav.querySelector('.ghost-header__mobile-panel');
    var openLabel = toggle.getAttribute('data-menu-open-label') || toggle.getAttribute('aria-label') || 'Open menu';
    var closeLabel = toggle.getAttribute('data-menu-close-label') || 'Close menu';
    var lastFocus = null;

    function openMenu() {
      lastFocus = document.activeElement;
      mobileNav.hidden = false;
      mobileNav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', closeLabel);
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        mobileNav.classList.add('is-open');
      });
      var closeButton = mobileNav.querySelector('.ghost-header__mobile-close');
      if (closeButton) closeButton.focus();
    }

    function closeMenu() {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', openLabel);
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        mobileNav.hidden = true;
      }, 280);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-ghost-menu-toggle]')) {
        event.preventDefault();
        if (mobileNav.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
        return;
      }

      if (event.target.closest('[data-ghost-menu-close]')) {
        closeMenu();
        return;
      }

      if (event.target.closest('.ghost-header__mobile-link')) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!mobileNav.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeMenu();
        return;
      }

      if (event.key !== 'Tab' || !panel) return;

      var focusables = getFocusable(panel);
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll('.ghost-header-wrap').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wrap = event.target.querySelector('.ghost-header-wrap');
    if (wrap) initMenu(wrap);
  });
})();
